import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GridOperatorCapacity from './grid-operator-capacity';
import GridOperatorCapacityDetail from './grid-operator-capacity-detail';
import GridOperatorCapacityUpdate from './grid-operator-capacity-update';
import GridOperatorCapacityDeleteDialog from './grid-operator-capacity-delete-dialog';

const GridOperatorCapacityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GridOperatorCapacity />} />
    <Route path="new" element={<GridOperatorCapacityUpdate />} />
    <Route path=":id">
      <Route index element={<GridOperatorCapacityDetail />} />
      <Route path="edit" element={<GridOperatorCapacityUpdate />} />
      <Route path="delete" element={<GridOperatorCapacityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GridOperatorCapacityRoutes;
